




































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SelectMonthComponent from '@/components/SelectMonthComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import { AgencyInvoice } from '@/domain/AgencyInvoice'
import { WindowPosition } from '@/domain/WindowPosition'
import AgencyInvoicesService, { SerchConditon } from '@/service/AgencyInvoicesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SelectMonthComponent,
    CustomerSelectDialogComponent,
    PdfViewComponent,
  },
})
export default class MemberAgencyInvoiceList extends Mixins(GlobalMixin) {
  agencyInvoicesService = AgencyInvoicesService.instance

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "代理店請求日", value: "agencyInvoiceOn", width: "130px" },
          { text: "代理店請求番号", value: "agencyInvoiceNo", width: "140px" },
          { text: "代理店名", value: "agencyInfo.customerName" },
          { text: "請求期間", value: "period", width: "220px" },
          { text: "小計", value: "amount", align: "end", filterable: false, width: "100px" },
          { text: "消費税", value: "tax", align: "end", filterable: false, width: "100px" },
          { text: "請求金額", value: "totalAmount", align: "end", filterable: false, width: "100px" },
          { text: "印刷", value: "printAt", align: "center", filterable: false, width: "80px" },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "120px" },
  ]
  list: AgencyInvoice[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  customerName = ""

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */
    const conditions = sessionStorage.getItem("tool.agency.invoice.list.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
    const searchFilter = sessionStorage.getItem("tool.agency.invoice.list.searchFilter")
    if (searchFilter !== null) {
      this.searchFilter = searchFilter
    }
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    sessionStorage.setItem("tool.agency.invoice.list.conditions", JSON.stringify(this.conditions))
    this.agencyInvoicesService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.mountedDataTable("tool.agency.invoice.list")
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター処理
   */
  // eslint-disable-next-line
  customFilter(value: any, search: string | null, item: AgencyInvoice): boolean {
    return this.filterCompare(search, item.filterKeyword)
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: AgencyInvoice) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.agencyInvoiceNo) {
      this.$router.push(`/member/agency/invoice/edit/${event.agencyInvoiceNo}`)
    }
    this.rowItemKey = event.agencyInvoiceNo
    this.rowItemClickTime = now
  }
  /**
   * 印刷ボタンのクリック
   */
  onPrint(agencyInvoiceNo: string) {
    this.agencyInvoicesService.print(agencyInvoiceNo)
      .then(dto => {
        this.list.filter(x => x.agencyInvoiceNo === agencyInvoiceNo)
            .forEach(x => x.printAt = dto.printAt)
        this.openPdfViewDialog("代理店請求書印刷", dto.agencyInvoiceFile.content)
      })
  }

  /**
   * フィルター変更
   */
  @Watch("searchFilter")
  changeSearchFilter() {
    sessionStorage.setItem("tool.agency.invoice.list.searchFilter", this.searchFilter)
  }

  /**
   * 画面を遷移する前の状態保存
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    sessionStorage.setItem("tool.agency.invoice.list.dataTableOptions", JSON.stringify(this.dataTableOptions))
    sessionStorage.setItem("tool.agency.invoice.list.windowPosition", JSON.stringify(WindowPosition.now()))
    next()
  }
}
